module.exports = __webpack_public_path__ + "img/logo.fa3345b7.svg";